module.exports = __webpack_public_path__ + "static/Muhammad Endhy Aziz-095eb4567510aa47d047e8c4b2a58832.jpg";